import React, { useEffect } from "react";
import PropTypes from "prop-types";
// --- Import Hooks
import useMakeRequest from "../../../hooks/useMakeRequest";
// --- Import Components
import NotificationError from "../../../components/UI/NotificationError/NotificationError";
import Preloader from "../../../components/UI/Preloader/Preloader";
import SubscriptionsListItem from "../SubscriptionsListItem/SubscriptionsListItem";
// --- Import Styles
import "./SubscriptionsList.sass";

function SubscriptionsList({ showRenew }) {
  const [setParams, result, isLoading, hasError, error] = useMakeRequest();
  useEffect(() => {
    setParams({ c: "accountStore", a: "userLicenses" });
  }, []);

  return (
    <>
      {result !== null && result?.length === 0 && (
        <NotificationError
          classWrapper="payment-section__error"
          classText="payment-section__error-text"
          errorMessage="You have no subscriptions"
        />
      )}
      {hasError && error !== "" && (
        <NotificationError
          classWrapper="payment-section__error"
          classText="payment-section__error-text"
          errorMessage={error}
        />
      )}
      {!isLoading && result && result?.length > 0 && (
        <table className="subscriptions-list">
          <thead className="subscriptions-list__head">
            <tr>
              <td className="subscriptions-list__head-cell">Description</td>
              <td className="subscriptions-list__head-cell">Billing date</td>
              <td className="subscriptions-list__head-cell visually-hidden">
                Actions
              </td>
            </tr>
          </thead>
          <tbody>
            {result.map((item) => {
              return (
                <SubscriptionsListItem
                  key={item.id}
                  product={item}
                  showRenew={showRenew}
                />
              );
            })}
          </tbody>
        </table>
      )}
      {isLoading && <Preloader className="subscriptions-list__loading" />}
    </>
  );
}

SubscriptionsList.propTypes = { showRenew: PropTypes.bool.isRequired };

export default SubscriptionsList;
